const translations = {
    scheduled: 'Scheduled'
};

export default translations;
